export function heroBackgroundAnimation() {
  const container = document.querySelector(
    "#tenesys-hero-background-animation",
  );
  if (!container) return;

  const sketch = (p) => {
    let BLUE_COLS, WHITE_COLS;
    let blueCurrH = [],
      blueStartH = [],
      blueTargetH = [];
    let whiteCurrH = [],
      whiteStartH = [],
      whiteTargetH = [];
    let animDuration = 1000,
      holdDuration = 3000;
    let animating = true,
      phaseStart = 0;

    const styles = getComputedStyle(container);

    const MAIN_BG = styles.getPropertyValue("--bg");
    const MAIN_BAR = styles.getPropertyValue("--bar-main");
    const WHITE_BAR = styles.getPropertyValue("--bar-secondary");
    const MARKER = styles.getPropertyValue("--marker");

    let markerCol = 0;
    let markerH = 10;

    const cw = () => container.clientWidth;
    const ch = () => container.clientHeight;

    function initBars() {
      BLUE_COLS = p.random() < 0.5 ? 4 : 6;
      WHITE_COLS = p.random() < 0.5 ? 3 : 5;

      blueCurrH = [];
      blueStartH = [];
      blueTargetH = [];
      whiteCurrH = [];
      whiteStartH = [];
      whiteTargetH = [];

      for (let i = 0; i < BLUE_COLS; i++) {
        let h = p.random(p.height * 0.2, p.height * 0.9);
        blueCurrH[i] = blueStartH[i] = blueTargetH[i] = h;
      }
      for (let i = 0; i < WHITE_COLS; i++) {
        let h = p.random(20, 120);
        whiteCurrH[i] = whiteStartH[i] = whiteTargetH[i] = h;
      }

      setNewTargets();
      phaseStart = p.millis();
      markerCol = p.floor(p.random(WHITE_COLS));
    }

    function setNewTargets() {
      for (let i = 0; i < BLUE_COLS; i++) {
        let h,
          guard = 0;
        do {
          h = p.random(p.height * 0.2, p.height * 0.9);
          guard++;
        } while (p.abs(h - blueCurrH[i]) < p.height * 0.08 && guard < 10);
        blueTargetH[i] = h;
      }

      for (let i = 0; i < WHITE_COLS; i++) {
        let h,
          guard = 0;
        do {
          h = p.random(20, 120);
          guard++;
        } while (p.abs(h - whiteCurrH[i]) < 10 && guard < 10);
        whiteTargetH[i] = h;
      }
    }

    function easeOutCubic(t) {
      let u = 1 - p.constrain(t, 0, 1);
      return 1 - u * u * u;
    }

    p.setup = () => {
      const canvas = p.createCanvas(cw(), ch());
      canvas.parent(container);
      p.frameRate(60);
      p.noStroke();
      initBars();
    };

    p.windowResized = () => {
      p.resizeCanvas(cw(), ch());
      initBars();
    };

    p.draw = () => {
      p.background(MAIN_BG);

      let now = p.millis();
      let elapsed = now - phaseStart;
      let eased = 1.0;

      if (animating) {
        let t = p.constrain(elapsed / animDuration, 0, 1);
        eased = easeOutCubic(t);

        for (let i = 0; i < BLUE_COLS; i++) {
          blueCurrH[i] = p.lerp(blueStartH[i], blueTargetH[i], eased);
        }
        for (let i = 0; i < WHITE_COLS; i++) {
          whiteCurrH[i] = p.lerp(whiteStartH[i], whiteTargetH[i], eased);
        }

        if (elapsed >= animDuration) {
          for (let i = 0; i < BLUE_COLS; i++) blueCurrH[i] = blueTargetH[i];
          for (let i = 0; i < WHITE_COLS; i++) whiteCurrH[i] = whiteTargetH[i];
          animating = false;
          phaseStart = now;
          eased = 1.0;
        }
      } else {
        if (elapsed >= holdDuration) {
          animating = true;
          phaseStart = now;
          for (let i = 0; i < BLUE_COLS; i++) blueStartH[i] = blueCurrH[i];
          for (let i = 0; i < WHITE_COLS; i++) whiteStartH[i] = whiteCurrH[i];
          setNewTargets();
          markerCol = p.floor(p.random(WHITE_COLS));
        }
      }

      let blueW = p.width / BLUE_COLS;
      p.fill(MAIN_BAR);
      for (let i = 0; i < BLUE_COLS; i++) {
        let x = i * blueW;
        let hB = blueCurrH[i];
        let y = p.height - hB;
        p.rect(x, y, blueW + 1, hB);
      }

      let whiteW = p.width / WHITE_COLS;
      p.fill(WHITE_BAR);
      for (let i = 0; i < WHITE_COLS; i++) {
        let x = i * whiteW;
        let hB = whiteCurrH[i];
        let y = p.height - hB;
        p.rect(x, y, whiteW + 1, hB);
      }

      let mw = whiteW / 6;
      let xStart = markerCol * whiteW;
      let xEnd = xStart + whiteW - mw;
      let mX = p.lerp(xStart, xEnd, eased);
      let mY = p.height - whiteCurrH[markerCol];

      p.fill(MARKER);
      p.rect(mX, mY, mw, markerH);
    };
  };

  return new p5(sketch);
}
